import { LoanForm } from './LoanForm';
import type { SchemaCreditRequestForm } from '../../../schemas/creditRequestForm.schema';
import { GESCHAEFTSKREDIT, type GESCHAEFTSKREDIT_TYPE } from '../../../types';
import { headers } from '../../constants';
import LoanCard from '../shared/LoanCard';

type Props = {
    credit: SchemaCreditRequestForm[GESCHAEFTSKREDIT_TYPE][number];
    index: number;
};

export const DetailedView = ({ credit, index }: Props) => (
    <td colSpan={headers.length} className="p-3">
        <LoanCard name={`${GESCHAEFTSKREDIT}.${index}`} credit={credit}>
            <LoanForm index={index} applicant={credit.gehoertZuAntragsteller} />
        </LoanCard>
    </td>
);
